<template>
  <div
    class="button d-flex justify-content-center align-items-center p-2 my-2"
    @click="$emit('click')"
  >
    <img
      src="https://cdn.vexels.com/img/google-icon.svg"
      width="16"
      :alt="$t('profile.logIn.main.googleIconAlt')"
      srcset=""
      class="mr-1"
    />
    <span v-if="login" :class="purchaseMode ? 'purchase-mode' : ''"
      >{{ $t('profile.logIn.main.logInWith') }}
      <span :class="purchaseMode ? '' : 'font-weight-bold'">Google</span></span
    >
    <span v-else :class="purchaseMode ? 'purchase-mode' : ''"
      >{{ $t('profile.signUp.main.signUpWith') }}
      <span :class="purchaseMode ? '' : 'font-weight-bold'">Google</span></span
    >
  </div>
</template>

<script>
export default {
  props: {
    login: {
      type: Boolean,
      required: false,
      default: false
    },
    purchaseMode: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  color: gray;
  cursor: pointer;
  border-radius: 0.5rem;
  background-color: $lightGray;

  span {
    font-size: 12px;
    white-space: nowrap;
    &.purchase-mode {
      color: black !important;
      font-size: 12px !important;
      font-weight: 500;
      span {
        color: black !important;
        font-size: 12px !important;
        font-weight: 500;
      }
    }
  }
}
</style>
